import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class SystemLocalStorageService {
    private systemsKey: string = 'userSystem';
    private defaultSystem: Array<string> = ['banco', 'palpal', 'skrill'];
    private systemTest: string = '';
    private systemsLocalStorage: Array<string> = [];

    public constructor(private localStorageService: LocalStorageService) {}

    public getSystem(): Array<string> {
        this.systemsLocalStorage = this.localStorageService.getItem(this.systemsKey);
        if (this.systemsLocalStorage) {
            return this.systemsLocalStorage.filter((system) => system !== this.systemTest);
        } else {
            this.localStorageService.setItem(this.systemsKey, this.defaultSystem);

            return this.defaultSystem.filter((system): boolean => system !== this.systemTest);
        }
    }

    public setSystemId(systemId: string): this {
        this.systemTest = systemId;

        return this;
    }

    public setSystemKey(systemsKey: string): this {
        this.systemsKey = systemsKey;

        return this;
    }

    public setSystemDefault(defaultSystems: Array<string>): this {
        this.defaultSystem = defaultSystems;

        return this;
    }

    public addSystem(systemId: string): void {
        if (this.systemsLocalStorage.includes(systemId)) {
            return;
        }
        this.systemsLocalStorage.push(systemId);
        this.localStorageService.setItem(this.systemsKey, this.systemsLocalStorage);
    }

    public replaceSystem(systemId: string, index: number): void {
        let indexAux: number = this.getSystem().length === this.systemsLocalStorage.length ? index : index + 1;
        this.systemsLocalStorage[indexAux] = systemId;
        this.localStorageService.setItem(this.systemsKey, this.systemsLocalStorage);
    }

    public deleteSystem(system_id: string): void {
        this.systemsLocalStorage = this.systemsLocalStorage.filter((systemLocal: string) => systemLocal !== system_id);
        this.localStorageService.setItem(this.systemsKey, this.systemsLocalStorage);
    }
}
